import type { OrgTreeNode } from '@vtak/shared';

/** An org-tree node paired with its indentation depth (0 = root). */
export interface FlatOrgUnit {
  node: OrgTreeNode;
  depth: number;
}

/** Depth-first flatten of an org tree node into (node, depth) rows. */
export function flattenTree(node: OrgTreeNode, depth: number): FlatOrgUnit[] {
  return [
    { node, depth },
    ...(node.children ?? []).flatMap((child) => flattenTree(child, depth + 1)),
  ];
}
